var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSchedule(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Groupe_84",
    "data-name": "Groupe 84",
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "customFill",
    fill: "black",
    id: "Trac\\xE9_157",
    "data-name": "Trac\\xE9 157",
    d: "M8.923,3.961A.961.961,0,1,0,7,3.961V14.536a.961.961,0,0,0,.485.834l6.73,3.845a.961.961,0,0,0,.954-1.669L8.923,13.979Z",
    transform: "translate(8.5 1.031)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "customFill",
    fill: "black",
    id: "Trac\\xE9_158",
    "data-name": "Trac\\xE9 158",
    d: "M16.5,33A16.5,16.5,0,1,0,0,16.5,16.5,16.5,0,0,0,16.5,33ZM30.938,16.5A14.438,14.438,0,1,1,16.5,2.062,14.437,14.437,0,0,1,30.938,16.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSchedule);
export default __webpack_public_path__ + "static/media/icon-schedule.b3edacaafb21e76730d60d250bd55350.svg";
export { ForwardRef as ReactComponent };